// src/scripts/mailer/installMailerRoute.js
import {
  doc,
  getDoc,
} from "firebase/firestore";

import {
  auth,
  authReady,
  db,
} from "@/firebase";

function clean(value) {
  return String(
    value ?? ""
  ).trim();
}

function asBool(value) {
  if (value === true) {
    return true;
  }

  if (value === false) {
    return false;
  }

  if (
    typeof value ===
    "string"
  ) {
    return (
      value
        .trim()
        .toLowerCase() ===
      "true"
    );
  }

  return false;
}

function userHasVenue(
  profile,
  venueId
) {
  const target =
    clean(venueId);

  if (!target) {
    return true;
  }

  const direct =
    clean(
      profile?.venue_id ||
        profile?.venueId ||
        profile?.activeVenueId ||
        profile?.venue ||
        ""
    );

  if (
    direct &&
    direct === target
  ) {
    return true;
  }

  const arrays = [
    profile?.venue_ids,
    profile?.venueIds,
    profile?.venues,
  ]
    .filter(
      Array.isArray
    )
    .flat()
    .map(clean);

  if (
    arrays.includes(
      target
    )
  ) {
    return true;
  }

  const maps = [
    profile?.venue_access,
    profile?.venueAccess,

    !Array.isArray(
      profile?.venues
    )
      ? profile?.venues
      : null,
  ];

  return maps.some(
    (
      map
    ) =>
      map &&
      typeof map ===
        "object" &&
      map[target] ===
        true
  );
}

async function mailerBeforeEnter(
  to
) {
  await authReady;

  const user =
    auth.currentUser;

  if (!user?.uid) {
    return {
      name:
        "Login",
    };
  }

  try {
    const [
      tokenResult,
      profileSnapshot,
    ] =
      await Promise.all([
        user
          .getIdTokenResult(),

        getDoc(
          doc(
            db,
            "users",
            user.uid
          )
        ),
      ]);

    const claims =
      tokenResult
        ?.claims ||
      {};

    const profile =
      profileSnapshot
        .exists()
        ? profileSnapshot
            .data() ||
          {}
        : {};

    const userType =
      clean(
        profile.user_type ||
          profile.userType
      ).toLowerCase();

    const operations =
      asBool(
        claims.operations
      ) ||
      asBool(
        claims.ops
      ) ||
      asBool(
        claims.is_operations
      ) ||
      asBool(
        profile.isOperations
      ) ||
      asBool(
        profile.is_operations
      ) ||
      asBool(
        profile.operations
      ) ||
      userType ===
        "operations";

    const socialMedia =
      asBool(
        claims.social_media
      ) ||
      asBool(
        claims.socialMedia
      ) ||
      asBool(
        claims.is_social_media
      ) ||
      asBool(
        profile.isSocialMedia
      ) ||
      asBool(
        profile.is_social_media
      ) ||
      asBool(
        profile.social_media
      ) ||
      userType ===
        "social_media";

    if (
      !operations &&
      !socialMedia
    ) {
      return {
        name:
          "VenueDashboard",

        params:
          to.params
            ?.venueId
            ? {
                venueId:
                  to
                    .params
                    .venueId,
              }
            : {},
      };
    }

    if (
      socialMedia &&
      !operations &&
      !userHasVenue(
        profile,
        to.params
          ?.venueId
      )
    ) {
      return {
        name:
          "ArtworkWorkflow",
      };
    }

    return true;
  } catch (error) {
    console.warn(
      "[MailerRoute] access check failed:",
      error
    );

    return {
      name:
        "Login",

      query: {
        reason:
          "unauthorised",
      },
    };
  }
}

export function installMailerRoute(
  router
) {
  if (
    !router ||
    router.hasRoute(
      "Mailer"
    )
  ) {
    return;
  }

  router.addRoute({
    /*
      "artwork" is intentionally included in this URL.

      Your existing router restricts Social Media accounts
      to artwork paths. This lets Mailer coexist with that
      existing guard without replacing router/index.js.

      Mailer then performs its own stricter access check.
    */
    path:
      "/:venueId?/marketing/artwork-mailer",

    name:
      "Mailer",

    component:
      () =>
        import(
          "@/views/MailerView.vue"
        ),

    beforeEnter:
      mailerBeforeEnter,

    meta: {
      requiresAuth:
        true,
    },

    props:
      true,
  });
}